// 注意，页面要先引入wx.mixin
import { getUserId, getToken } from '@/utils/utils'
import { shareBind } from 'api/live'

export default {
  methods: {
    // 如果是从分享链接进入，链接参数带userId，则需要登录从而绑定关系（3秒后登录）
    async handleShareBind() {
      setTimeout(() => {
        let shareUserId = this.$route.query.userId
        let activeUserId = getUserId()
        let token = getToken()
        let liveId = this.$route.query.id

        if (!shareUserId) return

        if (activeUserId) {
          shareBind({
            bindUserId: shareUserId,
            userId: activeUserId,
            token,
            liveId,
            type: this.type
          }).then(res => {
            console.log(res)
          })
        } else {
          this.handleLogin()
        }
      }, 3000)
    }
  },
  mounted() {
    this.handleShareBind()
  }
}
